import { isEntraConfigured } from './entraConfig';

export function EntraSignInButton({ onClick, busy = false, className = '' }) {
  if (!isEntraConfigured()) {
    return null;
  }
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      className={
        className ||
        'flex w-full items-center justify-center rounded-xl border border-eorig-border bg-white px-4 py-2.5 text-sm font-semibold text-eorig-ink transition hover:bg-eorig-surface disabled:opacity-60'
      }
    >
      {busy ? 'Redirecting to Microsoft…' : 'Sign in with Microsoft'}
    </button>
  );
}
